import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FiPlus, FiMinus, FiHelpCircle, FiChevronRight } from "react-icons/fi";

const FAQ = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I place an order or request an errand?", // Updated
      answer: "To place an order or request an errand, start a chat with our seller or OurASAP service, describe your needs (items or personalized task), provide details, and confirm your request.",
    },
    {
      question: "What kind of errands can I request?", // New Errand FAQ
      answer: "We handle a wide range of personalized errands, including electronics procurement, item pickups, and custom delivery tasks tailored to your specific needs.",
    },
    {
      question: "Can I track my delivery?",
      answer: "Yes! You can track your package in real-time through the website, with live updates at every stage of the transit process.",
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all secure payments through our platform. Note that payments made outside OurASAP are not covered by our safety guarantee or dispute services.",
    },
    {
      question: "How do I contact support?",
      answer: "You can reach out via email at ourasapservice@gmail.com or call 09026235719 for immediate assistance from our support team.",
    },
    {
      question: "Do you accept international delivery?",
      answer: "Yes, we provide seamless international delivery between the United Kingdom and African countries, and vice versa.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col relative overflow-hidden">
      {/* Decorative Blur (Matching Sell Product) */}
      <div className="absolute top-[-5%] right-[-10%] w-80 h-80 bg-orange-100 rounded-full blur-3xl opacity-40"></div>

      {/* Unified Header */}
      <div className="bg-white px-6 py-6 flex items-center shadow-sm border-b border-gray-100 relative z-20">
        <button 
          onClick={() => navigate(-1)} 
          className="p-2 -ml-2 hover:bg-gray-100 rounded-full transition text-gray-900"
        >
          <IoMdArrowBack size={24} />
        </button>
        <div className="ml-4">
          <h1 className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-600">Support</h1>
          <p className="text-xl font-black text-gray-900 tracking-tighter">Help Center (FAQ)</p>
        </div>
      </div>

      {/* Content Container */}
      <div className="flex-1 p-4 max-w-2xl mx-auto w-full relative z-10 pt-8 pb-20">
        <div className="bg-white rounded-[2.5rem] p-6 md:p-10 shadow-xl shadow-gray-200/50 border border-gray-100 space-y-8">
          
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
              <FiHelpCircle size={16} />
            </div>
            <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">Common Questions</h3>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`transition-all duration-300 rounded-2xl border ${
                  openIndex === index 
                    ? "border-orange-500 bg-orange-50/30" 
                    : "border-gray-100 bg-gray-50/50 hover:bg-gray-100"
                }`}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full text-left px-5 py-5 flex justify-between items-center outline-none"
                >
                  <span className={`text-sm font-black transition-colors ${
                    openIndex === index ? "text-orange-600" : "text-gray-800"
                  }`}>
                    {faq.question}
                  </span>
                  <div className={`transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""}`}>
                    {openIndex === index ? (
                      <FiMinus className="text-orange-600" size={18} />
                    ) : (
                      <FiPlus className="text-gray-400" size={18} />
                    )}
                  </div>
                </button>

                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 pb-5 text-sm font-bold text-gray-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;